import ApiService from "../../core/services/api.service";

const apiService = ApiService;

export default class UserService {
  #api = null;

  constructor() {
    this.#api = `admin/user`;
  }

  paginate(data, index = null) {
    let url = `${this.#api}`;
    if (index != null) url = `${url}?page=${index}`;
    let param = {
      params: data
    };
    return apiService.query(url, param);
  }

  all(data) {
    let url = `${this.#api}/get/all?name=${data}`;
    return apiService.query(url);
  }

  store(data) {
    let url = `${this.#api}`;
    return apiService.post(url, data);
  }

  show(id) {
    let url = `${this.#api}/${id}`;
    return apiService.get(url);
  }

  update(id, data) {
    let url = `${this.#api}/${id}`;
    return apiService.post(url, data);
  }

  delete(id) {
    let url = `${this.#api}/${id}`;
    return apiService.delete(url);
  }

  resetPassword(id) {
    let url = `${this.#api}/${id}/generate`;
    return apiService.post(url);
  }
}
